import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import { LightMode as LightModeIcon, DarkMode as DarkModeIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import useThemeMode from 'hooks/useThemeMode';

/**
 * Toggle de modo de tema (sol/luna) con los íconos convencionales de MUI.
 * Se coloca junto al selector de idioma, tanto dentro de la app como en login/register.
 * La lógica del cambio (Redux + localStorage + persistencia backend) vive en useThemeMode.
 */
function ThemeModeToggle({ color = undefined, size = '1.25rem' }) {
  const { t } = useTranslation(['buttons']);
  const { isDark, toggle: handleToggle } = useThemeMode();

  const label = isDark
    ? t('switchToLightMode', { defaultValue: 'Activar modo claro' })
    : t('switchToDarkMode', { defaultValue: 'Activar modo oscuro' });

  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        data-tour="theme-toggle"
        onClick={handleToggle}
        size="small"
        sx={{
          color: color || 'inherit',
          transition: 'color 200ms cubic-bezier(0.32, 0.72, 0, 1)',
          '&:hover': { color: 'gold.main', backgroundColor: 'action.hover' }
        }}>
        {isDark ? (
          <LightModeIcon sx={{ fontSize: size }} />
        ) : (
          <DarkModeIcon sx={{ fontSize: size }} />
        )}
      </IconButton>
    </Tooltip>
  );
}

ThemeModeToggle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ThemeModeToggle;
